module.exports = __webpack_public_path__ + "static/media/autobookCollector.1e7d77cd.svg";